import React from "react";


window.getTransitionEndEventName=()=> {
    var transitions = {
        "transition"      : "transitionend",
        "OTransition"     : "oTransitionEnd",
        "MozTransition"   : "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
     }
    let bodyStyle = document.body.style;
    for(let transition in transitions) {
        if(bodyStyle[transition] != undefined) {
            return transitions[transition];
        } 
    }
};

export default function WBkey(props){
    const {wbkey,variant}=props; 
    let asset = {};//window.wb.getAsset(wbkey);
    if (!asset) return "";
    const clickCourtain= (evcc)=>{
        document.getElementById("wbmodal").classList.add("closing");
        document.getElementById("wbcourtain").classList.add("closing");
        setTimeout(()=>{
            document.getElementById("wbmodal").remove();
            document.getElementById("wbcourtain").remove();
        },500);
    };
    const rightClick = (evrc)=>{
        evrc.preventDefault();
        evrc.stopPropagation();
        let wbembeddiv=document.createElement('div');
        let wbembedc=document.createElement('div');
        wbembeddiv.id="wbmodal";
        wbembedc.id="wbcourtain";
        wbembedc.onclick=clickCourtain;
        wbembeddiv.classList.add('wbkeyembed');
        wbembeddiv.innerHTML="<iframe src='https://api.cirma.local/website-asset/key/"+evrc.target.getAttribute('wbk')+"' />";
        document.body.appendChild(wbembedc);
        document.body.appendChild(wbembeddiv);
        //window.open('https://api.cirma.local/website-asset/key/'+evrc.target.getAttribute('wbk'));
    };
    const mouseOver = (evmo)=>{
        evmo.target.classList.add('wbover');
    };    
    const mouseOut = (evmo)=>{
        evmo.target.classList.remove('wbover');
    };
    if (!variant)
        switch(asset.type){
            case 1: return <span wbk={wbkey} onContextMenu={rightClick} onMouseOver={mouseOver}>{asset.label}</span>; break;
            case 2: return <span wbk={wbkey} onContextMenu={rightClick} onMouseOver={mouseOver} dangerouslySetInnerHTML={{__html: asset.html}} />; break;
            case 3: return <span wbk={wbkey} onContextMenu={rightClick} onMouseOver={mouseOver}>{asset.long_text}</span>; break;
            case 6: return <span wbk={wbkey} onContextMenu={rightClick} onMouseOver={mouseOver}>{asset.label}</span>; break;
        }
    if (variant=="plain")
        switch(asset.type){
            case 1: return asset.label; break;
            case 2: return asset.html; break;
            case 3: return asset.long_text; break;
            case 6: return asset.label; break;
        }
    if (variant=="href")
        return asset.href;
    return "";
   
}